import { Grid } from '@mui/material'
import { t } from 'i18next'
import {
  InputField,
  AutoCompleteField,
  DatePickerField
} from 'src/components/shared/ui/form/fields'
import { FormField } from 'src/enums/Form'
import { useGetPais, useGetSexo } from 'src/hooks/fetch/useCatalogoGeneralFilters'

export default function TipoPersonaFormFields({ monitorio }: { monitorio: boolean }): JSX.Element {
  const paisData = useGetPais(FormField.INTERVINIENTE_DIRECCION_PAIS)
  const sexoData = useGetSexo(FormField.INTERVINIENTE_SEXO)

  return (
    <>
      <Grid item xs={12} sm={6} lg={4}>
        <InputField
          id={FormField.INTERVINIENTE_PRIMER_APELLIDO}
          label={t('form.field.primer_apellido')}
          required
          maxLength={100}
        />
      </Grid>
      <Grid item xs={12} sm={6} lg={4}>
        <InputField
          id={FormField.INTERVINIENTE_SEGUNDO_APELLIDO}
          label={t('form.field.segundo_apellido')}
          maxLength={50}
        />
      </Grid>
      <Grid item xs={12} sm={6} lg={4}>
        <AutoCompleteField
          id={FormField.INTERVINIENTE_SEXO}
          label={t('form.field.sexo')}
          items={sexoData}
          itemName="descripcion"
        />
      </Grid>
      {monitorio && (
        <Grid item xs={12} sm={6} lg={4}>
          <InputField
            id={FormField.INTERVINIENTE_TELEFONO}
            type="tel"
            label={t('form.field.telefono')}
            maxLength={12}
          />
        </Grid>
      )}
      {monitorio && (
        <Grid item xs={12} sm={6} lg={4}>
          <InputField
            id={FormField.INTERVINIENTE_EMAIL}
            label={t('form.field.email')}
            maxLength={50}
            type="email"
          />
        </Grid>
      )}
      <Grid item xs={12} sm={6} lg={4}>
        <DatePickerField
          id={FormField.INTERVINIENTE_FECHA_NACIMIENTO}
          label={t('form.field.fecha_nacimiento')}
          disableFuture
        />
      </Grid>
      <Grid item xs={12} sm={6} lg={4}>
        <InputField
          id={FormField.INTERVINIENTE_LUGAR_NACIMIENTO}
          label={t('form.field.lugar_nacimiento')}
          maxLength={50}
        />
      </Grid>
      <Grid item xs={12} sm={6} lg={4}>
        <AutoCompleteField
          id={FormField.INTERVINIENTE_PAIS_NACIMIENTO}
          label={t('form.field.pais_nacimiento')}
          items={paisData}
          itemName="nombre"
        />
      </Grid>
      <Grid item xs={12} sm={6} lg={4}>
        <AutoCompleteField
          id={FormField.INTERVINIENTE_NACIONALIDAD}
          label={t('form.field.nacionalidad')}
          items={paisData}
          itemName="nombre"
        />
      </Grid>
      <Grid item xs={12} sm={6} lg={4}>
        <InputField
          id={FormField.INTERVINIENTE_NOMBRE_PADRE}
          label={t('form.field.nombre_padre')}
          maxLength={50}
        />
      </Grid>
      <Grid item xs={12} sm={6} lg={4}>
        <InputField
          id={FormField.INTERVINIENTE_NOMBRE_MADRE}
          label={t('form.field.nombre_madre')}
          maxLength={50}
        />
      </Grid>
    </>
  )
}
